export const CampaignState = {
  Available: 'available',
  Participating: 'participating',
  Completed: 'completed',
  OptedOut: 'opted_out',
  Paused: 'paused',
  Disqualified: 'disqualified',
} as const;

export type CampaignState = (typeof CampaignState)[keyof typeof CampaignState];
